import xyPlane from "../media/other/xyplane.png"
import airplane from "../media/other/AirplaneV2_1.png"
import { CopyBlock, dracula } from "react-code-blocks"
import Button from "react-bootstrap/Button"

const varsSnippet = `
  cloudsBig;
  cloudsSmall;
  ground;
  hills;
  mountains;
`

const loadAssetsSnippet = `
    this.load.setBaseURL(
      "https://game-course-resources.s3.us-west-2.amazonaws.com"
    );
    // Load background
    this.load.image("clouds-big", "cloudsBig.png");
    this.load.image("clouds-small", "cloudsSmall.png");
    this.load.image("mountains", "Mountains.png");
    this.load.image("hills", "Hills.png");
    this.load.image("ground", "Ground.png");
`

const createAssetsSnippet = `
    this.mountains = this.add.tileSprite(640, 480, 1280, 400, "mountains");
    this.hills = this.add.tileSprite(640, 480, 1280, 400, "hills");
    this.ground = this.add.tileSprite(640, 520, 1280, 400, "ground");
    this.cloudsBig = this.add.tileSprite(640, 200, 1280, 400, "clouds-big");
    this.cloudsSmall = this.add.tileSprite(640, 200, 1280, 400, "clouds-small");
`

const Sprites = () => (
  <>
    <h1>Let's talk Sprites</h1>
    <b>
      <i>
        Sprite: a computer graphic which may be moved on-screen and otherwise
        manipulated as a single entity.
      </i>
    </b>
    <br />
    <br />
    <p>
      Sprites are graphics which we can use for backgrounds, objects, players,
      enemies and etc.. for our game. For this lesson I will provide all the
      assests we need to make a simple game. Below is an example and our player
      sprite that we are going to use in our game.
    </p>
    <img alt="Airplane sprite image" src={airplane} width={600} height={400} />
    <br />
    <p>
      When rendering sprites in our game we set the coordinates on and xy plane
      where the origin starts at the top left corner.
    </p>
    <img alt="xy plane image" src={xyPlane} width={600} height={400} />
    <br />
    <br />
    <p>
      Lets start off by adding in our background for the game. Just below the
      first line that says MYGame insert the following code:
    </p>
    <CopyBlock
      text={varsSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      There are called variables, we are going to assign values to them. Inside
      of the preload function paste the following code:
    </p>
    <CopyBlock
      text={loadAssetsSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      What we are doing is telling Phaser where the images are located. Then the
      names of the images. Even though they are loaded we still don't see
      anything, thats because we have to tell Phaser where to put theme. Copy
      and paste the code snippet below into the create function.
    </p>
    <CopyBlock
      text={createAssetsSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      You should now see a screen with mountains, hills, clouds and ground. We
      are using a specific kind of sprite called a TileSprite which repeats the
      image. This will make more sense soon.
    </p>
    <a
      href="https://docs.phaser.io/api-documentation/class/gameobjects-gameobjectfactory#tilesprite"
      target="_blank"
    >
      Tile Sprite Documentation
    </a>
    <p>
      We tell phaser to show these in this order so it knows which ones to draw
      first. Meaning mountains, then hills, then ground etc... This is called
      <b> layering</b>.
    </p>

    <br />
    <br />
    <Button type="button" variant="secondary" href="/Animation">
      Next
    </Button>
    <br />
    <br />
  </>
)

export default Sprites
